import * as React from 'react'
import { connect } from 'react-redux'
import { currentNavigatorStackSelector, currentNavigatorIndexSelector } from '../../../selectors/navigation'
import { navigateToIndex } from '../../../actions/navigation'
import { Breadcrumb } from './breadcrumb'
import { RootState } from '../../../types/rootstate'

import '../../../sass/answers/breadcrumbs.scss'
import { navigateToArticle, navigateToCategory, navigateToStart } from '../../../actions/answers'

export type BreadcrumbItem = {
  type: 'start' | 'answersDetails' | 'answersCategory' | 'answersSearchResults'
  label: string
  navigationParams: {
    [key: string]: number | string
  }
}

interface StateProps {
}

interface DispatchProps {
  navigateToIndex: (index: number) => void
  navigateToArticle: (userId: number, answersId: number, articleId: number) => void
  navigateToCategory: (userId: number, answersId: number, categoryId: number, categoryName: string) => void
  navigateToStart: () => void
}

interface OwnProps {
  breadcrumbs: BreadcrumbItem[]
}

type BreadcrumbsProps = StateProps & DispatchProps & OwnProps

function mapStateToProps (state: RootState): StateProps {
  return {
  }
}

function mapDispatchToProps(dispatch): DispatchProps {
  return {
    navigateToIndex: (index) =>
      dispatch(navigateToIndex(index)),
    navigateToArticle: (userId, answersId, articleId) =>
      dispatch(navigateToArticle(userId, answersId, articleId)),
    navigateToCategory: (userId, answersId, categoryId, categoryName) =>
      dispatch(navigateToCategory(userId, answersId, categoryId, categoryName)),
    navigateToStart: () => dispatch(navigateToStart())
  }
}

interface BreadcrumbsState {
}

class BreadcrumbsComponent extends React.Component<BreadcrumbsProps, BreadcrumbsState> {
  handleBreadcrumbClick = (breadcrumb: BreadcrumbItem) => {
    if (breadcrumb.type === 'start') {
      this.props.navigateToStart()
    } else if (breadcrumb.type === 'answersCategory') {
      this.props.navigateToCategory(
        breadcrumb.navigationParams.userId as number,
        breadcrumb.navigationParams.answersId as number,
        breadcrumb.navigationParams.categoryId as number,
        breadcrumb.navigationParams.categoryName as string
      )
    }
  }

  render() {
    return (
      <div className="col-xs-12">
        <ol className="breadcrumbs">
          {this.props.breadcrumbs.map((breadcrumb) =>
            <Breadcrumb
              key={breadcrumb.type}
              item={breadcrumb}
              onClick={this.handleBreadcrumbClick} />
            )}
        </ol>
      </div>
    )
  }
}

const Breadcrumbs = connect<StateProps, DispatchProps, OwnProps>(mapStateToProps, mapDispatchToProps)(BreadcrumbsComponent)


export {
  Breadcrumbs
}
